import { Record } from 'immutable';
const APIResponse = Record({
  error: null,
  result: null
}, 'APIResult');
export default APIResponse;